import { useAuthStore } from "@/stores/auth-store";
import { authenticatedRequest } from "@/lib/graphql/client";
import { LOGOUT_MUTATION } from "@/lib/graphql/queries/auth";

export async function performLogout(): Promise<void> {
  const { getAccessToken, clearAuth } = useAuthStore.getState();
  const accessToken = getAccessToken();

  if (accessToken) {
    try {
      await authenticatedRequest(LOGOUT_MUTATION);
    } catch {
      // Server error should not block client-side cleanup
    }
  }

  clearAuth();
}
